"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var types_1 = __importDefault(require("../types"));
function chatUsersReducer(state, action) {
    var _a, _b;
    var _c, _d;
    switch (action.type) {
        case types_1["default"].SET_MYSELF: {
            var user_1 = action.payload;
            lodash_1["default"].keys(state.rooms).forEach(function (roomId) {
                var room = state.rooms[roomId];
                if (!room.isDirect)
                    return null;
                if (!room.userId)
                    return null;
                var userId = room.userId.replace(user_1._id, '');
                if (room.userId === userId)
                    return null;
                state = state.setIn(['rooms', roomId, 'userId'], userId);
            });
            return state.merge({ me: user_1 });
        }
        case types_1["default"].ADD_USER: {
            var userRocket = action.payload;
            var user = __assign(__assign({ 
                // @ts-ignore
                customFields: {} }, userRocket), { storeUpdatedAt: Date.now(), user_id: (_c = userRocket.customFields) === null || _c === void 0 ? void 0 : _c.user_id, thumbnail: (_d = userRocket.customFields) === null || _d === void 0 ? void 0 : _d.avatar_url });
            var rooms = state.rooms;
            var room = lodash_1["default"].find(state.rooms, { userId: user._id });
            if (room) {
                room = room.merge({ thumbnail: user.thumbnail, userId: user._id, name: user.name });
                rooms = rooms.merge((_a = {},
                    _a[room._id] = room,
                    _a));
            }
            return state.merge({
                users: state.users.merge((_b = {}, _b[user._id] = user, _b)),
                rooms: rooms
            });
        }
        case types_1["default"].ADD_USER_TO_IGNORED: {
            var ignoreUser = action.payload;
            return state.merge({
                ignoreUsers: state.ignoreUsers.concat(ignoreUser)
            });
        }
        default:
            return state;
    }
}
exports["default"] = chatUsersReducer;
